import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FfrHost, FfrServer } from '@/types/ffr';
import { FfrServerMenu } from './FfrServerMenu';
import { FfrPartPlayer } from './FfrPartPlayer';

interface Props {
  servers: FfrServer[];
  titleId: string;
}

/**
 * Composes the server switcher + per-part sandboxed-iframe player. `servers` is
 * pre-ordered by the backend (okru → dailymotion → filemoon), so the first
 * entry is the best-UX default. Guaranteed non-empty by the caller
 * (WatchSportsVod only mounts this when servers.length > 0).
 */
export function FfrMultiServerPlayer({ servers, titleId }: Props): JSX.Element {
  const { t } = useTranslation();
  const [activeHost, setActiveHost] = useState<FfrHost>(servers[0].host);
  const active = servers.find((s) => s.host === activeHost) ?? servers[0];

  return (
    <div className="ffr-multiserver" data-testid="ffr-multiserver">
      <div className="ffr-multiserver__bar">
        <span className="ffr-multiserver__notice">{t('ffr.adNotice')}</span>
        <FfrServerMenu servers={servers} activeHost={active.host} onSelect={setActiveHost} />
      </div>
      <FfrPartPlayer server={active} titleId={titleId} />
    </div>
  );
}
